import { duration } from '@vy/utils';
import { MutationCache, QueryClient } from 'react-query';
import { isSandboxEnvironment } from './env-indicator';
import { setGlobalVariable } from './global-variables/global-variables';

export const isStagingEnvironment = window.location.hostname.includes('staging-app.dev.withvayu.com');
const FIVE_MINUTE_DURATION = duration(5, 'minutes').asMilliseconds();

export const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: FIVE_MINUTE_DURATION,
      refetchOnWindowFocus: !isStagingEnvironment,
      refetchOnReconnect: !isStagingEnvironment,
      refetchInterval: isStagingEnvironment ? false : undefined,
    },
  },
  mutationCache: new MutationCache({
    onMutate: async () => {
      if (isSandboxEnvironment()) {
        setGlobalVariable('showSandboxDialog', true);
      }
    },
  }),
});
